import React from 'react';
import styles from './ColorInput.module.css';

export interface ColorInputProps {
  id?: string;
  value: string; // hex format #RRGGBB or #RRGGBBAA
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void; // Or a callback returning the hex value
  disabled?: boolean;
  className?: string;
}

export const ColorInput: React.FC<ColorInputProps> = ({
  id,
  value,
  onChange,
  disabled = false,
  className = '',
}) => {
  // <input type="color"> expects #RRGGBB format
  const internalValue = value.length > 7 ? value.substring(0, 7) : value;

  return (
    <input
      type="color"
      id={id}
      value={internalValue}
      onChange={onChange}
      disabled={disabled}
      className={`${styles.colorPicker} ${className}`}
    />
  );
};